import BaseApi from './BaseApi';
import { stringify } from 'qs';
import { CONTACTS_RESOURCE_NAME } from '../config/constants';

export default class ContactsApi extends BaseApi {
  static [`get${CONTACTS_RESOURCE_NAME}`](params, cancelToken) {
    const q = params ? `?${stringify(params)}` : '';
    return this.get(`/contact${q}`, cancelToken);
  }

  static [`getOneOf${CONTACTS_RESOURCE_NAME}`]({ id }, cancelToken) {
    return this.get(`/contact/${id}`, cancelToken);
  }

  static [`create${CONTACTS_RESOURCE_NAME}`](payload) {
    return this.post('/contact', payload);
  }

  static [`createBulk${CONTACTS_RESOURCE_NAME}`](payload, cancelToken) {
    return this.post('/contact/list', payload, cancelToken);
  }

  static [`update${CONTACTS_RESOURCE_NAME}`](payload) {
    return this.put('/contact', payload);
  }

  static [`blacklist${CONTACTS_RESOURCE_NAME}`]({ ids, addOrRemove }, cancelToken) {
    let toOrFrom;
    if (addOrRemove === 'add') {
      toOrFrom = 'to';
    } else if (addOrRemove === 'remove') {
      toOrFrom = 'from';
    }
    return this.put(`/contact/${toOrFrom}-black-list?ids=${ids.join(',')}`, cancelToken);
  }

  static [`deleteOneOf${CONTACTS_RESOURCE_NAME}`]({ id }, cancelToken) {
    return this.delete(`/contact/${id}`, cancelToken);
  }

  static [`delete${CONTACTS_RESOURCE_NAME}`]({ ids }, cancelToken) {
    return this.delete(`/contact?ids=${ids.join(',')}`, cancelToken);
  }
  static [`download${CONTACTS_RESOURCE_NAME}`]({ids}, cancelToken) {
    return this.getFile(`contact/export-contacts?ids=${ids.join(',')}`, cancelToken);
  }
}
